import { useSelector } from 'react-redux';

import selectResumeBuilderBasePath from '@glass/web/modules/content/selectors/selectResumeBuilderBasePath';

const useBuilderBasePath = () => useSelector(selectResumeBuilderBasePath);

export default useBuilderBasePath;
